import React, {Component, Fragment} from 'react'
import {Route} from 'react-router-dom'
import Question from './Question'
import NewQuestion from './NewQuestion'
import Leaderboard from './Leaderboard'
import ListQuestion from './ListQuestion'
import Error from './Error'

//dashboard contains all component routes and is rendered in app.js
class Dashboard extends Component {
	state = {
		questions: []
	}
	sortQuestions = (e) => {
		let value = e ? e.target.value : 'new';
		let questions = this.props.questions;
		if (value === 'popular') {
			this.setState({
				questions: Object.keys(questions).sort((a,b) => (questions[a].optionOne.votes + questions[a].optionTwo.votes) < (questions[b].optionOne.votes + questions[b].optionTwo.votes))
			})
		} else if (value === 'old') {
			this.setState({
				questions: Object.keys(questions).sort((a, b) => questions[a].timestamp > questions[b].timestamp)
			})
		} else {
			this.setState({
				questions: Object.keys(questions).sort((a, b) => questions[a].timestamp < questions[b].timestamp)
			})
		}
	}
  render() {
		let questions = this.state.questions.length ? this.state.questions
			: Object.keys(this.props.questions).sort((a, b) => this.props.questions[a].timestamp < this.props.questions[b].timestamp);
    return (
      <Fragment>
        <Route exact path="/" render={() =>
          <section className="container">
						<div>
	            <button className="active-button" onClick={this.props.showUnanswered}>Unanswered Questions</button>
	            <button className="inactive-button" onClick={this.props.showAnswered}>Answered Questions</button>
						</div>
						<select onChange={this.sortQuestions}>
							<option value="new">New</option>
							<option value="old">Old</option>
							<option value="popular">Popular</option>
						</select>
            <ul>
              {questions.map((question) => (
                <Question key={question} question={this.props.questions[question]}/>
              ))}
            </ul>
          </section>
        }/>
        <Route path="/add" component={NewQuestion} />
        <Route path="/leaderboard" component={Leaderboard} />
        <Route path="/questions/" component={ListQuestion}/>
        <Route path="/404" component={Error}/>
      </Fragment>
    )
  }
}

export default (Dashboard)
